import { render, staticRenderFns } from "./fundNav.vue?vue&type=template&id=c813c3f4"
import script from "./fundNav.vue?vue&type=script&lang=js"
export * from "./fundNav.vue?vue&type=script&lang=js"
import style0 from "./fundNav.vue?vue&type=style&index=0&id=c813c3f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports